import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { ApiVersionModel } from "../../../shared/models/api-version.model";

@Injectable({ providedIn: 'root' })
export class ApiVersionService {

    private url = environment.apiUrl; 
    private api = this.url + "/version" ;

    constructor(private http: HttpClient) {} 
   


    getVersion(): Observable<ApiVersionModel> {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

        return this.http.get<ApiVersionModel>(this.api, { headers }).pipe(
        map(data => new ApiVersionModel(data))    
        );
    }



}
